import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject, fromEvent } from 'rxjs';
import { takeUntil, distinctUntilChanged, tap, debounceTime, filter } from 'rxjs/operators';
import { AuthService } from 'src/app/auth/auth.service';
import { SPINNER, NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-epc-user-reports',
  templateUrl: './epc-user-reports.component.html',
  styleUrls: ['./epc-user-reports.component.scss']
})
export class EpcUserReportsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('inputWmsSearch', { static: false }) inputWmsSearch: ElementRef;
  @ViewChild('inputNormalSearch', { static: false }) inputNormalSearch: ElementRef;
  @ViewChild('inputZESearch', { static: false }) inputZESearch: ElementRef;
  @ViewChild('inputDGSearch', { static: false }) inputDGSearch: ElementRef;
  private ResponseVerifiedWms$: Subject<any> = new Subject();
  private ResponseVerifiedNormal$: Subject<any> = new Subject();
  private ResponseVerifiedZEUserList: Subject<any> = new Subject();

  SadminAccess: any = [];
  loaders: any[];
  userRole: any;
  page = 1;
  page1 = 1;
  resultObject: any = {};
  resultObjectusserCount: any = {};
  role: any;
  roleName: any;
  totalUser: any;
  totalDevices: any;
  activeDevices: any;
  inactiveDevices: any;
  epcUser: any;
  normalUser: any;
  wmsUser: any;
  totalSolarCapacity: any;
  totalEnergyGenerated: any;
  co2EmmisionSaved: any;
  totalDeviceInstalled: any;
  totalProject: any;
  search: any = '';
  limit: any = 10;
  offset: any = 0;
  dgUserListCount: any = 0;
  deviceObj: any = {};
  dataOfUser: any;
  dataOfNormalUser: any;
  selectedTab: any;
  normalCount: any;
  wmsCount: any;
  public message: string;
  public token: any;
  public id: any;
  public emp_id: any;
  public password: any;
  public name: any;
  login_id: string;
  public logo: any;
  company_name: string;
  isview: any;
  epc_id: string;
  through: string;
  strSearch: string;
  dataObject: any;
  zeUserListCount: any;
  zeUserList = [];
  dgUserList = [];
  admin_id: any;
  is_emeter: any;
  is_wms: any
  constructor(private ngxUiLoaderService: NgxUiLoaderService, private dashboardService: DashboardService, private router: Router,
    private route: ActivatedRoute, private toastr: ToastrService) {

    this.role = localStorage.role;
    this.name = localStorage.name;
    if (this.role === '1') {
      this.roleName = 'admin';
    } else if (this.role === '2') {
      this.roleName = 'epc';
      this.through = 'epc';
    } else if (this.role === '3') {
      this.roleName = 'wms';
    } else if (this.role === '4') {
      this.roleName = 'normal';
    }
    this.route.queryParams.subscribe(params => {
      this.selectedTab = params.selectedTab;
    });
    // For Multiple Loaders
    this.loaders = [
      {
        loaderId: 'loader-01',
        spinnerType: SPINNER.ballScaleMultiple,
      },
      { // used
        // hasProgressBar: true,
        loaderId: 'loader-02',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
      },
      {
        loaderId: 'loader-03',
        spinnerType: SPINNER.ballScaleMultiple,
      },
      {
        loaderId: 'loader-04',
        spinnerType: SPINNER.ballScaleMultiple,
      },
    ];

  }

  ngOnInit() {
    if (this.role === '2') {
      if (this.selectedTab === 'normalUserReport') {

        this.getDeviceDataOfNormalUser(this.search, this.limit, this.offset);
      }
      else if (this.selectedTab === 'wmsUserReport') {

        this.getDeviceDataOfWmsUser(this.search, this.limit, this.offset);
      }
      else if (this.selectedTab === 'zeUserReport') {
        this.getDeviceDataOfZeUser(this.search, this.limit, this.offset);
      }
      else if (this.selectedTab === 'dgUserReport') {
        this.getDeviceDataOfDgUser(this.search, this.limit, this.offset);
      } else {
        this.showNormalUserReportTab('normalUserReport');
        this.getDeviceDataOfNormalUser(this.search, this.limit, this.offset);
      }
    }
  }

  ngAfterViewInit() {

    // search wms user by  key press event
    fromEvent(this.inputWmsSearch.nativeElement, 'keyup')
      .pipe(
        filter(Boolean),
        debounceTime(500),  // event every 500 milliseconds.
        distinctUntilChanged(),
        tap((event: KeyboardEvent) => {
          this.search = this.inputWmsSearch.nativeElement.value;
          this.getDeviceDataOfWmsUser(this.search, this.limit, '0');
        })
      )
      .subscribe();
    // search normal user by  key press event
    fromEvent(this.inputNormalSearch.nativeElement, 'keyup')
      .pipe(
        filter(Boolean),
        debounceTime(500), // event every 500 milliseconds.
        distinctUntilChanged(),
        tap((event: KeyboardEvent) => {
          this.search = this.inputNormalSearch.nativeElement.value
          this.getDeviceDataOfNormalUser(this.search, this.limit, '0');
        })
      )
      .subscribe();
    // search ZE user by  key press event
    fromEvent(this.inputZESearch.nativeElement, 'keyup')
      .pipe(
        filter(Boolean),
        debounceTime(500), // event every 500 milliseconds.
        distinctUntilChanged(),
        tap((event: KeyboardEvent) => {
          this.search = this.inputZESearch.nativeElement.value
          this.getDeviceDataOfZeUser(this.search, this.limit, '0');
        })
      )
      .subscribe();
    // search DG user by  key press event
    fromEvent(this.inputDGSearch.nativeElement, 'keyup')
      .pipe(
        filter(Boolean),
        debounceTime(500), // event every 500 milliseconds.
        distinctUntilChanged(),
        tap((event: KeyboardEvent) => {
          this.search = this.inputDGSearch.nativeElement.value
          this.getDeviceDataOfDgUser(this.search, this.limit, '0');
        })
      )
      .subscribe();
  }

  showWmsUserReportTab(selectedTab) {
    this.selectedTab = selectedTab;
    this.offset = 0;
    this.strSearch = '';
    this.getDeviceDataOfWmsUser(this.strSearch, this.limit, this.offset);
  }
  showNormalUserReportTab(selectedTab) {

    this.selectedTab = selectedTab;
    this.offset = 0;
    this.strSearch = '';
    this.getDeviceDataOfNormalUser(this.strSearch, this.limit, this.offset);
  }
  showZeUserReportTab(selectedTab) {
    this.selectedTab = selectedTab;
    this.offset = 0;
    this.strSearch = '';
    this.getDeviceDataOfZeUser(this.strSearch, this.limit, this.offset);
  }
  showDgUserReportTab(selectedTab) {
    this.selectedTab = selectedTab;
    this.offset = 0;
    this.strSearch = '';
    this.getDeviceDataOfDgUser(this.strSearch, this.limit, this.offset);
  }

  // get Device Data of user live data for wms user
  getDeviceDataOfWmsUser(search, limit, offset) {
    this.ngxUiLoaderService.startBackgroundLoader(this.loaders[0].loaderId);
    // this.wmsCount = 0;
    this.dataOfUser = [];
    if (offset === 0) {
      this.page1 = 1;
    }
    this.deviceObj = {
      search: search,
      limit: limit,
      offset: offset,
      role: 3
    };
    this.dashboardService.getDeviceDataOfUser(this.deviceObj)
      .pipe(takeUntil(this.ResponseVerifiedWms$))
      .subscribe(
        async data => {
          this.wmsCount = 0;
          if (data.status) {
            this.wmsCount = data.count;
            this.dataOfUser = data.resultObject;
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[0].loaderId);
          } else if (!data.status) {
            if (data.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(['/login']);

            } else {
              this.toastr.info(data.message);

            }
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[0].loaderId);
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // get Device Data of user live data for normal user
  getDeviceDataOfNormalUser(search, limit, offset) {
    if (offset === 0) {
      this.page = 1;
    }
    // this.normalCount = 0;
    this.dataOfNormalUser = [];
    this.deviceObj = {
      'search': search,
      'limit': limit,
      'offset': offset,
      'role': 4
    };
    this.ngxUiLoaderService.startBackgroundLoader(this.loaders[1].loaderId);
    this.dashboardService.getDeviceDataOfUser(this.deviceObj)
      .pipe(takeUntil(this.ResponseVerifiedNormal$))
      .subscribe(
        async data => {
          this.normalCount = 0;
          if (data.status) {
            this.normalCount = data.count;
            this.dataOfNormalUser = data.resultObject;
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[1].loaderId);
          } else if (!data.status) {
            if (data.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(['/login']);

            } else {
              this.toastr.info(data.message);

            }
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[1].loaderId);
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // get device data for ze user
  getDeviceDataOfZeUser(search, limit, offset) {
    this.ngxUiLoaderService.startBackgroundLoader(this.loaders[2].loaderId);
    if (offset == 0) {
      this.page = 1;
    }

    this.dataObject = {
      search: search,
      limit: limit,
      offset: offset,
      'role': 6
    }

    this.dashboardService.getDeviceDataOfUser(this.dataObject)
      .pipe(takeUntil(this.ResponseVerifiedZEUserList))
      .subscribe(
        async data => {
          this.normalCount = 0;
          if (data.status) {
            this.normalCount = data.count;
            this.zeUserList = data.resultObject;
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[2].loaderId);
          }
          else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info('Login Time-out .. Please login again');
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
              this.normalCount = data.resultObject;

            }
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[2].loaderId);
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // get device data for dg user
  getDeviceDataOfDgUser(search, limit, offset) {
    this.ngxUiLoaderService.startBackgroundLoader(this.loaders[3].loaderId);
    if (offset == 0) {
      this.page = 1;
    }
    this.dataObject = {
      search: search,
      limit: limit,
      offset: offset,
      'role': 7
    }
    this.dashboardService.getDeviceDataOfUser(this.dataObject)
      .pipe(takeUntil(this.ResponseVerifiedZEUserList))
      .subscribe(
        async data => {
          this.normalCount = 0;
          if (data.status) {
            this.normalCount = data.count;
            this.dgUserList = data.resultObject;
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[3].loaderId);
          }
          else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info('Login Time-out .. Please login again');
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
              this.normalCount = data.resultObject;
            }
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[3].loaderId);
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  nextPageNormalUserReport(pageIndex): void {
    this.offset = (pageIndex - 1) * 10;
    this.getDeviceDataOfNormalUser(this.search, this.limit, this.offset);
  }
  nextPageWmsUserReport(pageIndex): void {
    this.offset = (pageIndex - 1) * 10;
    this.getDeviceDataOfWmsUser(this.search, this.limit, this.offset);
  }
  nextPageZeUserReport(pageIndex): void {
    this.offset = (pageIndex - 1) * 10;
    this.getDeviceDataOfZeUser(this.search, this.limit, this.offset);
  }
  nextPageDgUserReport(pageIndex): void {
    this.offset = (pageIndex - 1) * 10;
    this.getDeviceDataOfDgUser(this.search, this.limit, this.offset);
  }
  viewPortalWmsUser(frm) {
    var loginObj = {
      user_id: frm,
      isview: true
    };
    this.dashboardService.loginViewPortal(loginObj)
      .pipe(takeUntil(this.ResponseVerifiedNormal$))
      .subscribe(
        data => {
          if (data.status) {
            localStorage.clear();
            this.toastr.success(data.message);
            this.token = data.resultObject.token;
            this.role = data.resultObject.role;
            this.id = data.resultObject.id;
            this.name = data.resultObject.name;
            this.login_id = data.resultObject.login_id;
            this.logo = data.resultObject.logo;
            this.company_name = data.resultObject.company_name;
            this.epc_id = data.resultObject.epc_id;
            this.SadminAccess = data.resultObject.SadminAccess;
            this.isview = data.isview;
            this.is_emeter = data.resultObject.is_emeter;
            this.is_wms = data.resultObject.is_wms;

            localStorage.setItem('loginToken', this.token);
            localStorage.setItem('role', this.role);
            localStorage.setItem('name', this.name);
            localStorage.setItem('id', this.id);
            localStorage.setItem('login_id', this.login_id);
            localStorage.setItem('logo', this.logo);
            localStorage.setItem('company_name', this.company_name);
            localStorage.setItem('epc_id', this.epc_id);
            localStorage.setItem('isview', this.isview);
            localStorage.setItem('through', this.through);
            localStorage.setItem('SadminAccess', JSON.stringify(this.SadminAccess) || '[]');
            localStorage.setItem('admin_id', this.admin_id);
            localStorage.setItem('is_emeter', this.is_emeter);
            localStorage.setItem('is_wms', this.is_wms);
            this.router.navigate(['/inject-solar/dashboard/'])
              .then(() => {
                window.location.reload();
              });
          } else if (!data.status) {
            if (data.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(data.message);
            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  ngOnDestroy() {
    this.ResponseVerifiedWms$.next();
    this.ResponseVerifiedWms$.complete();
    this.ResponseVerifiedNormal$.next();
    this.ResponseVerifiedNormal$.complete();
  }

}


